export const Colors = {
    primaryColor: "#c2308d",
    secondaryColor: "#1a0f82"
}